import LocalStorageHelper from '@/helpers/localStorageHelper';

export const persistPlugin = (store) => {
    const savedState = LocalStorageHelper.getItem('persistItems');
    if (savedState) {
        store.replaceState({
            ...store.state,
            ['persistItems']: {
                ...store.state['persistItems'],
                ...savedState
            },
        });
        LocalStorageHelper.removeItem('persistItems');
    }

    window.addEventListener('beforeunload', () => {
        LocalStorageHelper.setItem('persistItems', store.state["persistItems"]);
    });
};